<template>
  <!-- eslint-disable vue/no-bare-strings-in-template -->
  <ul class="actions center">
    <li v-if="isSessionPending">
      <button type="button" :disabled="sessionIsStarting" @click.prevent="startSession">start session</button>
    </li>

    <li v-else-if="isSessionFinished">Finished</li>

    <li v-else-if="isRoundPaused">
      <button type="button" @click.prevent="endRoundPause">
        <span v-if="session.currentRound.isLastRoundOfYear">start next year</span>
        <span v-else>start next month</span>
      </button>
    </li>

    <li v-else-if="isRoundActive">
      <button v-if="session.pausesAfterRound" type="button" @click="unPauseAfterRound">
        do not pause after current month
      </button>
      <button v-else type="button" :disabled="isFirstRound" @click="pauseAfterRound">pause after current month</button>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { router } from '@inertiajs/vue3'
import { computed, ref } from 'vue'

import { http } from '/@front:shared/http'
import { error, success } from '/@front:shared/notifications'
import type { GameSession } from '/@front:types/shared'

const props = defineProps<{
  session: GameSession
  links: Record<string, string>
}>()

const isSessionPending = computed(() => props.session.status.value === 'pending')
const isSessionFinished = computed(() => props.session.status.value === 'finished')
const isRoundPaused = computed(() => props.session.roundStatus.value === 'paused')
const isRoundActive = computed(() => props.session.roundStatus.value === 'active')
const isFirstRound = computed(() => props.session.currentRound.id === 1)

const sessionIsStarting = ref(false)

const startSession = () => {
  sessionIsStarting.value = true

  http
    .post(props.links.sessionStatus, {
      status: 'playing',
    })
    .then(() => {
      success('Session is starting…')
    })
    .catch(() => {
      error('Failed to start session.')
    })
    .finally(() => {
      router.reload()
    })
}

const endRoundPause = () => {
  http
    .post(props.links.roundStatus, {
      status: 'active',
    })
    .then(() => {
      success('Starting next round.')
    })
    .catch(() => {
      error('Failed to start new round.')
    })
}

const pauseAfterRound = () => {
  http
    .post(props.links.sessionSettings, {
      shouldPauseAfterCurrentRound: true,
    })
    .then(() => router.reload())
}

const unPauseAfterRound = () => {
  http
    .post(props.links.sessionSettings, {
      shouldPauseAfterCurrentRound: false,
    })
    .then(() => router.reload())
}
</script>
